<template>
    <div class="row">
        <div class="col-xs-12">
            <div class="box box-primary">
                <div class="box-header with-border">
                    <h3 class="box-title">Offers</h3>
                    <div class="box-tools pull-right">
                        <button
                            :class="isDisabled(isOffersFetching)"
                            :disabled="isOffersFetching"
                            class="btn btn-box-tool"
                            title="Collapse"
                            type="button"
                            @click="emitOffersClick"
                        >
                            <i
                                :class="changeIcon(collapse)"
                                class="fa"
                            ></i>
                        </button>
                    </div>
                </div>
                <!-- /.box-header -->
                <vue-slide-up-down
                    :active="collapse"
                    :duration="durationCollapse"
                >
                    <div v-if="isOffersFetching && collapse">
                        <div class="text-center">
                            <img
                                alt="Preloader"
                                class="table-row-preloader"
                                rel="preload"
                                src="/img/table-row-preloader.gif"
                            />
                        </div>
                    </div>
                    <div v-else-if="!isOffersFetching">
                        <div
                            v-if="!dataLength"
                            class="box-body"
                        >
                            <p>There are no Offers in the system</p>
                        </div>
                        <div
                            v-else
                            class="box-body table-responsive no-padding"
                        >
                            <table class="table table-hover offers-table">
                                <thead>
                                    <tr>
                                        <th class="text-left">ID</th>
                                        <th class="text-left">Offer</th>
                                        <th class="text-left">Messages</th>
                                        <th class="text-left">Clicks</th>
                                        <th class="text-left">Revenues</th>
                                        <th class="text-left">eCPM/EPC</th>
                                        <th class="text-right open-all">
                                            <span
                                                class="btn btn-sm btn-primary open-offer"
                                                @click="triggerAll"
                                            >
                                                <i
                                                    v-if="allDataIcon.arrowDownIcon"
                                                    class="fa fa-caret-down"
                                                ></i>
                                                <i
                                                    v-if="allDataIcon.arrowUpIcon"
                                                    class="fa fa-caret-up"
                                                ></i>
                                                <i
                                                    v-if="allDataIcon.refreshIcon"
                                                    class="fa fa-refresh fa-spin"
                                                ></i>
                                                <span class="sr-only">Show All</span>
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody
                                    v-for="(offer, index) in offers"
                                    :key="index"
                                >
                                    <tr>
                                        <td v-if="offer.id === 0">
                                            <em class="text-info">None</em>
                                        </td>
                                        <td v-else>{{ offer.id }}</td>
                                        <td>
                                            <a
                                                v-if="offer.id"
                                                :href="getRoute(offer.id, 'offers')"
                                            >
                                                {{ offer.name }}
                                            </a>
                                            <em
                                                v-else
                                                class="text-info"
                                                >None</em
                                            >
                                        </td>
                                        <td>
                                            <BadgeTotal
                                                :value="offer.messages_count"
                                                BadgeTotal
                                                color="gray"
                                                title="Total"
                                            />
                                            <BadgeTotal
                                                :value="offer.messages_sent"
                                                color="green"
                                                title="Sent"
                                            />
                                            <BadgeTotal
                                                :value="offer.messages_failed"
                                                color="red"
                                                title="Failed"
                                            />
                                            <BadgeTotal
                                                :value="offer.messages_blacklisted"
                                                color="black"
                                                title="Blacklisted"
                                            />
                                        </td>
                                        <td>
                                            <BadgeTotal
                                                :value="offer.percentage + '%'"
                                                color="light-blue"
                                                title="Percentage"
                                            />
                                            <BadgeTotal
                                                :value="offer.clicks_count"
                                                color="aqua-active"
                                                title="Amount"
                                            />
                                        </td>
                                        <td>
                                            <BadgeTotal
                                                :value="'$' + offer.revenues_prepared_value"
                                                color="light-blue"
                                                title="Amount"
                                            />
                                            <BadgeTotal
                                                :value="offer.revenues_count"
                                                color="aqua-active"
                                                title="Count"
                                            />
                                        </td>
                                        <td>
                                            <BadgeTotal
                                                :value="offer.ecpm_prepared_value"
                                                color="light-blue"
                                                title="eCPM"
                                            />
                                            <BadgeTotal
                                                :value="offer.epc_prepared_value"
                                                color="aqua-active"
                                                title="EPC"
                                            />
                                        </td>
                                        <td class="text-right">
                                            <span @click="processCarrierData(offer.id, categoryId, 'lists_categories', index)">
                                                <ToggleBtn
                                                    ref="allButtons"
                                                    :arrow-down-icon="offer.arrowDownIcon"
                                                    :arrow-up-icon="offer.arrowUpIcon"
                                                    :refresh-icon="offer.refreshIcon"
                                                />
                                            </span>
                                        </td>
                                    </tr>
                                    <OffersCarrierTemplateComponent
                                        :carriers="offersCarriersData[offer.id]"
                                        :is-stats-fetching="offer.isStatsFetching"
                                        :toggle-btn="offer.arrowUpIcon"
                                    />
                                </tbody>
                            </table>
                        </div>
                    </div>
                </vue-slide-up-down>
            </div>
        </div>
    </div>
</template>

<script>
import BadgeTotal from '../../subcomponents/BadgeTotal';
import ToggleBtn from '../../subcomponents/ToggleBtn';
import OffersCarrierTemplateComponent from './OffersCarrierTemplateComponent';
import EventBus from '../../../event-bus';

export default {
    components: {
        BadgeTotal,
        ToggleBtn,
        OffersCarrierTemplateComponent,
    },
    props: {
        offersData: {
            type: Array,
            default: () => [],
        },

        categoryId: {
            type: Number,
            default: null,
        },

        isOffersFetching: {
            type: Boolean,
            default: false,
        },

        toggleBtn: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            offersCarriersData: {},
            allDataIcon: {
                refreshIcon: false,
                arrowDownIcon: true,
                arrowUpIcon: false,
            },
            allDataIsFetching: false,
            allDataIsLoading: true,
            route: {
                offers: '/offers/:id:',
            },
            durationCollapse: 700,
            collapse: this.toggleBtn,
        };
    },

    computed: {
        offers: function () {
            return this.offersData;
        },
        dataLength: function () {
            return this.offers.length;
        },
    },

    watch: {
        toggleBtn: function (value) {
            this.collapse = value;
        },
    },

    methods: {
        isDisabled: function (value) {
            return value ? 'disabled-box' : '';
        },
        changeIcon: function (value) {
            return value ? 'fa-minus' : 'fa-plus';
        },
        triggerAll: function () {
            let app = this;
            app.$refs.allButtons.forEach((btn) => {
                btn.$el.click();
            });
            if (_.size(app.offersCarriersData) !== _.size(app.offers)) {
                app.allDataIcon.refreshIcon = true;
                app.allDataIcon.arrowDownIcon = false;
                app.allDataIcon.arrowUpIcon = false;
            } else if (app.allDataIcon.arrowUpIcon === true) {
                app.allDataIcon.refreshIcon = false;
                app.allDataIcon.arrowDownIcon = true;
                app.allDataIcon.arrowUpIcon = false;
            } else if (app.allDataIcon.arrowDownIcon === true) {
                app.allDataIcon.refreshIcon = false;
                app.allDataIcon.arrowDownIcon = false;
                app.allDataIcon.arrowUpIcon = true;
            }
        },
        processCarrierData: function (offerId, categoryId, type, id) {
            let app = this;
            app.$forceUpdate();
            if (app.offers[id].arrowDownIcon && !app.offersCarriersData[offerId]) {
                app.offers[id].isStatsFetching = true;
                app.offers[id].refreshIcon = true;
                app.offers[id].arrowDownIcon = false;
                app.offers[id].arrowUpIcon = false;
                axios
                    .post('/ajax/carrier-stats-json', {
                        id: categoryId,
                        type: type,
                        offerId: offerId,
                        filter: [],
                    })
                    .then(function (response) {
                        app.$forceUpdate();
                        app.offers[id].refreshIcon = false;
                        app.offers[id].arrowDownIcon = false;
                        app.offers[id].arrowUpIcon = true;
                        app.offersCarriersData[offerId] = _.orderBy(response.data.carriers, 'id', 'asc');
                        app.offers[id].isStatsFetching = false;
                        if (_.size(app.offersCarriersData) === _.size(app.offers)) {
                            app.allDataIcon.refreshIcon = false;
                            app.allDataIcon.arrowDownIcon = false;
                            app.allDataIcon.arrowUpIcon = true;
                        }
                    });
            } else if (app.offers[id].arrowDownIcon === true) {
                app.offers[id].refreshIcon = false;
                app.offers[id].arrowDownIcon = false;
                app.offers[id].arrowUpIcon = true;
            } else if (app.offers[id].arrowUpIcon === true) {
                app.offers[id].refreshIcon = false;
                app.offers[id].arrowDownIcon = true;
                app.offers[id].arrowUpIcon = false;
            }
        },
        emitOffersClick() {
            this.collapse = !this.toggleBtn;
            EventBus.$emit('clicksOffers', {
                getOffers: this.collapse,
            });
        },
        getRoute: function (id, type) {
            return this.route[type].replace(':id:', id);
        },
    },
};
</script>
